import { render, staticRenderFns } from "./CreateBankAccountForm.vue?vue&type=template&id=a3e6d906"
import script from "./CreateBankAccountForm.vue?vue&type=script&lang=js"
export * from "./CreateBankAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports